export default {
  'ec.user.dropdowm.item.text.password': 'Change Password',
  'ec.user.dropdowm.item.text.style': 'System Style',
  'ec.user.dropdowm.item.text.logout': 'Log Out',
}
